export default "__VITE_ASSET__B$KCqiNs__"